import type { ZudokuConfig } from "zudoku";

const basePath="";

const config: ZudokuConfig = {
  basePath: basePath,
  page: {
    showPoweredBy: false,
    logoUrl: basePath + "/logo.png",
  },
  redirects: [
    { from: "/", to: "/introduction" },
  ],
  topNavigation: [
    { id: "docs", label: "Get Started" },
    { id: "biz_api", label: "Biz API Reference" },
    { id: "merchant_api", label: "Merchant API Reference" },
  ],
  metadata: {
    title: "%s | Got It",
    description: "Got It open api documentation",
  },
  sidebar: {
    docs: [
      {
        type: "category",
        label: "Biz API",
        items: [
          "biz/biz-api",
          "biz/biz-api-security",
          "biz/biz-api-errorcodes"
        ],
      },
      {
        type: "category",
        label: "Merchant API",
        items: [
          "merchants/merchant-api",
          "merchants/merchant-api-reserve-flow",
          "merchants/merchant-api-skip-reserve-flow",
          "merchants/merchant-api-errorcodes"
        ],
      },
    ],
  },
  apis: [
    {
      type: "file",
      input: "./apis/merchant-api-v6.yaml",
      navigationId: "merchant_api",
    },
    {
      type: "file",
      input: [
        "./apis/biz-api-v5.yaml",
        "./apis/biz-api-v4.yaml",
      ],
      navigationId: "biz_api",
    },
  ],
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
};

export default config;
